export enum WorkerEvent {
  reservationCreated = "reservationCreated"
}
